import { render, staticRenderFns } from "./newMode.vue?vue&type=template&id=50495d9a&scoped=true&"
import script from "./newMode.vue?vue&type=script&lang=js&"
export * from "./newMode.vue?vue&type=script&lang=js&"
import style0 from "./newMode.vue?vue&type=style&index=0&id=50495d9a&lang=scss&scoped=true&"
import style1 from "./newMode.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50495d9a",
  null
  
)

export default component.exports